<template>
  <div>
    <v-app-bar
      :clipped-left="$vuetify.breakpoint.lgAndUp"
      app
      color="primary"
      height="80"
      elevation="8"
    >
      <v-row no-gutters class="ml-n4">
        <div
          class="d-flex align-center justify-space-between"
          style="width: 100%"
        >
          <div :class="titleStyle">
            <div class="float-left mt-4 mx-1">
              <v-app-bar-nav-icon @click.stop="drawer = !drawer" />
            </div>
            <div class="float-left mt-5">
              <a :href="`${payfastUrl}`" target="_blank" rel="noreferrer">
                <img
                  :src="`${cdnUrl}/assets/images/logos/payfast_by_network_white.png`"
                  :srcset="`${cdnUrl}/assets/images/logos/payfast_by_network_white@2.png`"
                  height="50px"
                  alt="Payfast by Network"
                />
              </a>
            </div>
            <div class="float-left mt-7 ml-6">
              <v-chip
                class="px-2 py-0"
                color="primaryAccent"
                label
                small
                text-color="primary"
              >
                <b class="header-chip">{{ titleText }}</b>
              </v-chip>
            </div>
            <SideBar v-model="drawer" />
          </div>
          <div class="d-none d-sm-block right-container">
            <div class="d-flex justify-end align-center">
              <Searchbar class="search-bar" />
              <TopBarLinks />
            </div>
          </div>
        </div>
      </v-row>
    </v-app-bar>
    <SideBar :drawer="drawer" v-on:update:drawer="drawer = $event" />
  </div>
</template>

<script>
import SideBar from "./SideBar";
import Searchbar from "./Searchbar";
import TopBarLinks from "./TopBarLinks";

export default {
  name: "TopBar",
  components: { TopBarLinks, Searchbar, SideBar },
  data: () => ({
    drawer: null,
    windowWidth: window.innerWidth,
  }),
  computed: {
    titleText() {
      return this.$route.name === "api" ? "API" : "Docs";
    },
    titleStyle() {
      return this.windowWidth > 1264
        ? "header_bg_title header_bg_color"
        : "header_bg_title";
    },
    cdnUrl() {
      return process.env.VUE_APP_CDN_URL;
    },
    payfastUrl() {
      return process.env.VUE_APP_PAYFAST_URL;
    },
  },
};
</script>

<style lang="scss" scoped>
$btn-active-opacity: 1 !default;
.header_bg_title {
  height: 80px;
  width: 300px;
  margin: 0;
}

.header_bg_color {
  background-color: $atlanticBlue;
}

.header-chip {
  color: $atlanticBlue !important;
  font-size: 13px;
  font-weight: 700;
  line-height: 24px;
}

.right-container {
  div:not(:last-child) {
    margin-left: 0;
  }

  @media (min-width: 1250px) {
    min-width: 50%;
    div:not(:last-child) {
      margin-right: 24px;
    }
  }
}

.search-bar {
  display: none;
  @media (min-width: 980px) {
    width: 40%;
    display: inline-flex;
  }

  @media (min-width: 1000px) {
    display: inline-flex;
  }
}
</style>
